import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useEffect, useState } from "react";
import storePersist from "../../redux/storePersist";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import GetQuote from "../../models/GetQuote";
import ProfileAddress from "../../models/ProfileAddress";
import { selectCurrent as selectUserCurrent } from "../../redux/user/selectors";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";
import _ from 'lodash'
import { settings } from "../../redux/settings/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { leads } from "../../redux/leads/action";
import { selectCmsSettingsListItems } from "../../redux/cmsSettings/selector";
import { cargoLeads } from "../../redux/cargo-lead/action";
import { selectOneConfigurationsQueryItems } from "../../redux/one-configurations/selector";
import { oneConfigurations } from "../../redux/one-configurations/action";
const logoimage = require("../../assets/img/onexbg.png");

const HeaderV2 = () => {
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const _user = storePersist.get('user')
	const [color, setColor] = useState('universal')
	const result = useSelector(selectCurrent)
	const { header, footer, visible, theme, lightLogo, darkLogo, favIcon, primary, secondary } = result
	const organizationLists = useSelector(selectOrganizationUnitsListItems)
	const { viewProfile } = useSelector(selectUserCurrent)
	const navigate = useNavigate()
	const [logo, setLogo] = useState<any>()
	const cmsSettings = useSelector(selectCmsSettingsListItems)
	const oneConfigurationItems = useSelector(selectOneConfigurationsQueryItems)




	useEffect(() => {
		setLogo(lightLogo || darkLogo)
	}, [result]);
	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}
	const handleProfile = () => {
		navigate('/logistics/profile')
		// dispatch(user.set({ viewProfile: 'open' }))
	}

	const handleMentors = async () => {
		await navigate('/catalyst')
	}

	const handleHome = async () => {
		localStorage.removeItem('access-token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('userProfile')
		await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await navigate('/')
	}
	// const handleCargo = async () => {
	// 	localStorage.removeItem('access-token')
	// 	localStorage.removeItem('accessTokenMetadata')
	// 	localStorage.removeItem('userProfile')
	// 	await dispatch(leads.resetAction({ actionType: 'create' }))
	// 	await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
	// 	await navigate('/cargo')
	// }
	const handleAcademy = async () => {
		await navigate('/academy')
	}
	const handleCommunities = async () => {
		await navigate('/communities')
	}
	const handleEcosystem = async () => {
		await navigate('/ecosystem')
	}

	const handleEvents = async () => {
		await navigate('/events')
	}
	const handleMembership = async () => {
		await navigate('/membership')
	}

	const handleSupport = async () => {
		await navigate('customer/support')
	}

	const handleVentures = async () => {
		await navigate('/venture-view')
	}

	const handlePartner = async () => {
		await navigate('/partners')
	}

	const handleAgencies = async () => {
		await navigate('/agencies-view')
	}

	const handlePartners = async () => {
		await navigate('/partners')
	}

	const handleDigiit = async () => {
		await navigate('/digiit')
	}

	const handleDbnNetwork = async () => {
		await navigate('/dbn-network')
	}

	const handleRaiseFrame = async () => {
		await navigate('/raise-frame')
	}

	const handleTestimonial = async () => {
		await navigate('/testimonial')
	}

	const HTMLContent: any = ({ htmlContent }: any) => {
		return (
			<div
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		);
	};


	const fetchOneQueryById = () => {
		dispatch(oneConfigurations.query({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/one/query`, entity: 'oneConfigurations',
			jsonData: {
			}
		}))
	}

	useEffect(
		() => {

			fetchOneQueryById()


		},
		[]
	)
	return (
		<>
			{width && width < 720 ?
				<>


					<header className={`fixed w-screen z-10  flex items-center justify-between px-1 py-1  top-0 h-20 bg-primary`}>
						<div className="flex flex-col w-full justify-start items-center space-y-3 ">
							<div className="flex w-full justify-between items-center py-4 ">
								<div className="flex justify-start items-center text-xl italic uppercase ml-6 " >
									{logo && <img src={logo} className={` w-20 h-12`} />}
								</div>
								<div className="flex flex-col items-center justify-center space-y-1 mx-2">
									<button aria-label="Login" className="p-2 bg-secondary rounded-full" onClick={() => handleNavigate('/auth/login/customer')}>
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="white" fill="none">
											<path d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
											<path d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z" stroke="currentColor" stroke-width="1.5" />
										</svg>
									</button>
									<span className="text-white text-xs">Login</span>
								</div>
								{/* <ul className={`flex  text-light mr-5 rounded-2xl`}>

											<li className="mr-6 p-2">
												<div className="flex flex-col items-center justify-center space-y-1">
													<button aria-label="Login" className="p-2 bg-secondary hover:bg-hilight rounded-full" onClick={() => handleNavigate('/auth/login/customer')}>
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="white" fill="none">
															<path d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
															<path d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z" stroke="currentColor" stroke-width="1.5" />
														</svg>
													</button>
													<span className="text-white hover:text-[#FFB934] text-xs">Login</span>
												</div>
											</li>
											<li className=" px-4 rounded-3xl flex flex-row space-x-1 flex item-center justify-center">
												<svg className="my-3" version="1.1" fill={primary} id="layer" width="18" height="18" viewBox="0 0 612 612">
													<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
		C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
		c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
		 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
		c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
		h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
		c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
		 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
		c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
		c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
		c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
		l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
		c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
		C565.257,281.569,563.532,285.839,560.084,285.839z"/>
												</svg>
												<a className="hover:text-[#FFB934] uppercase text-xs my-3" href="#">Your Cart</a>
											</li>
										</ul> */}
							</div>
						</div>
						<GetQuote />
					</header>

				</>
				: <>

					<div className={`flex flex-col items-center justify-center w-full bg-slate-800`}>
						<div className="flex items-center text-light justify-between h-16 w-full px-20">
							<div className="flex items-center justify-start">
								{/* Logo */}
								<div className="flex justify-start w-20 h-14">
									{logo && <img src={logo} className="w-full h-14" />}
								</div>

								{/* Navigation - moved slightly right using ml-6 */}
								<ul className="flex cursor-pointer ml-6">
									<li className="mr-2 p-2">
										<a className="hover:opacity-75 text-base" onClick={handleHome}>Home</a>
									</li>
									<li className="mr-2 p-2">
										<a className="hover:opacity-75 text-base" onClick={handleCommunities}>Communities</a>
									</li>
									<li className="mr-2 p-2">
										<a className="hover:opacity-75 text-base" onClick={handleAcademy}>Academy</a>
									</li>
									<li className="mr-2 p-2">
										<a className="hover:opacity-75 text-base" onClick={handleEcosystem}>Ecosystem</a>
									</li>
									<li className="mr-2 p-2">
										<a className="hover:opacity-75 text-base" onClick={handleEvents}>Events</a>
									</li>

								</ul>
							</div>

							<ul className="flex justify-end cursor-pointer">
								<li className="mr-2" onClick={handlePartners}>
									<div className="flex hover:opacity-75 items-center border-r-2 border-light">
										{/* <HTMLContent htmlContent={oneConfigurationItems?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.FavIcon} /> */}
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffffff" fill="none">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99023 11.75C7.65023 11.75 5.74023 9.84 5.74023 7.5C5.74023 5.16 7.65023 3.25 9.99023 3.25C12.3302 3.25 14.2402 5.16 14.2402 7.5C14.2402 9.84 12.3302 11.75 9.99023 11.75ZM9.99023 4.75C8.47023 4.75 7.24023 5.98 7.24023 7.5C7.24023 9.02 8.47023 10.25 9.99023 10.25C11.5102 10.25 12.7402 9.02 12.7402 7.5C12.7402 5.98 11.5102 4.75 9.99023 4.75ZM15.7402 20.0001C15.7402 20.4101 16.0802 20.7501 16.4902 20.7501C16.9002 20.7501 17.2402 20.4101 17.2402 20.0001V17.97C17.2402 16.32 16.4302 14.9101 15.1102 14.3101C12.0402 12.9301 7.95024 12.9201 4.87024 14.3101C3.55024 14.9101 2.74023 16.31 2.74023 17.97V20.0001C2.74023 20.4101 3.08023 20.7501 3.49023 20.7501C3.90023 20.7501 4.24023 20.4101 4.24023 20.0001V17.97C4.24023 17.13 4.57023 16.0901 5.49023 15.6701C8.18023 14.4601 11.8102 14.4601 14.4902 15.6701C15.4102 16.1001 15.7402 17.14 15.7402 17.97V20.0001ZM19.7407 20.0001C19.7407 20.4101 20.0807 20.7501 20.4907 20.7501L20.5007 20.74C20.9107 20.74 21.2507 20.4 21.2507 19.99V17.96C21.2507 16.3 20.4307 14.9001 19.1207 14.3101C18.8407 14.1901 18.5507 14.07 18.2507 13.96C17.8607 13.81 17.4307 14.0201 17.2907 14.4101C17.1507 14.8001 17.3507 15.23 17.7407 15.37C17.9907 15.47 18.2407 15.5701 18.4907 15.6801C19.4107 16.1001 19.7407 17.14 19.7407 17.97V20.0001ZM14.271 11.06C14.371 11.39 14.671 11.6 14.991 11.6V11.61C15.061 11.61 15.131 11.5999 15.201 11.5799C17.021 11.0399 18.241 9.38 18.241 7.51C18.241 5.64 16.991 3.96004 15.201 3.43004C14.811 3.31004 14.391 3.53004 14.271 3.93004C14.151 4.32004 14.371 4.73997 14.771 4.85997C15.921 5.19997 16.731 6.27999 16.731 7.49999C16.731 8.71999 15.941 9.77999 14.771 10.13C14.381 10.25 14.151 10.66 14.271 11.06Z" fill="#ffffffff" />
										</svg>
										<span className="pl-3  text-base pr-2">Partners</span>
									</div>
								</li>
								<li className="mr-2" onClick={handleDigiit}>
									<div className="flex hover:opacity-75 items-center border-r-2 border-light">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffffff" fill="none">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.5C17.93 1.5 22.75 6.32 22.75 12.25C22.75 18.16 17.96 22.97 12.06 23H12H11.95C6.04 22.97 1.25 18.18 1.25 12.25C1.25 6.32 6.07 1.5 12 1.5ZM16.74 16.39C16.38 18.29 15.79 19.84 15.05 20.97H15.07C18.45 19.79 20.93 16.7 21.23 13H19.52C19.11 13 18.77 12.66 18.77 12.25C18.77 11.84 19.11 11.5 19.52 11.5H21.23C20.93 7.8 18.45 4.72 15.07 3.53C15.81 4.66 16.4 6.21 16.76 8.11C16.84 8.52 16.57 8.91 16.16 8.99C16.135 8.99 16.1125 8.9925 16.09 8.995C16.0675 8.9975 16.045 9 16.02 9C15.67 9 15.35 8.75 15.28 8.39C14.68 5.22 13.33 3 12.02 3C10.71 3 9.36 5.22 8.76 8.39C8.68 8.8 8.29 9.06 7.88 8.99C7.47 8.91 7.21 8.52 7.28 8.11C7.64 6.21 8.23 4.66 8.97 3.53C5.59 4.71 3.11 7.8 2.81 11.5H4.52C4.93 11.5 5.27 11.84 5.27 12.25C5.27 12.66 4.93 13 4.52 13H2.81C3.1 16.7 5.59 19.79 8.97 20.97C8.23 19.84 7.64 18.29 7.28 16.39C7.2 15.98 7.47 15.59 7.88 15.51C8.29 15.44 8.68 15.7 8.76 16.11C9.36 19.28 10.7 21.5 12.01 21.5C13.32 21.49 14.66 19.27 15.26 16.11C15.34 15.7 15.73 15.44 16.14 15.51C16.55 15.59 16.81 15.98 16.74 16.39ZM14.02 10.37L15.94 11.08C16.43 11.26 16.75 11.72 16.75 12.25C16.75 12.78 16.43 13.23 15.94 13.42L14.02 14.13C13.95 14.15 13.9 14.2 13.88 14.27L13.17 16.19C12.99 16.68 12.53 17 12 17C11.47 17 11.02 16.68 10.83 16.19L10.12 14.27C10.1 14.21 10.05 14.16 9.98 14.13L8.06 13.42C7.57 13.24 7.25 12.78 7.25 12.25C7.25 11.72 7.57 11.27 8.06 11.08L9.98 10.37C10.05 10.35 10.1 10.3 10.12 10.23L10.83 8.31C11.01 7.82 11.47 7.5 12 7.5C12.53 7.5 12.98 7.82 13.17 8.31L13.88 10.23C13.9 10.29 13.95 10.34 14.02 10.37ZM12.47 13.74C12.65 13.26 13.02 12.89 13.5 12.71L14.77 12.24L13.5 11.77C13.03 11.6 12.65 11.22 12.47 10.75L12 9.48L11.53 10.75C11.35 11.23 10.98 11.6 10.5 11.78L9.23 12.25L10.5 12.72C10.97 12.89 11.35 13.27 11.53 13.74L12 15.01L12.47 13.74Z" fill="#ffffffff" />
										</svg>
										<span className="pl-3  text-base pr-2">Digiit.AI</span>
									</div>
								</li>

								{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.ShowMarketplaceMenuInHeader &&

									<li className="mr-2" onClick={() => window.open(oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.MarketplaceUrl)}>

										<div className="flex  hover:opacity-75 items-center border-r-2 border-light">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffffff" fill="none">
												<defs />
												<path fill="#ffffffff" d="M20.697,3.127 C20.779,3.422 20.814,3.733 20.841,3.971 L20.848,4.03 C20.937,4.799 21.202,5.539 21.875,6.355 C22.536,7.157 22.796,7.986 22.741,8.751 C22.687,9.501 22.334,10.125 21.882,10.526 C21.23,11.103 19.673,12.247 17.794,11.514 C17.006,11.207 16.399,10.798 15.977,10.209 C15.93,10.143 15.886,10.076 15.844,10.008 C15.769,10.096 15.69,10.182 15.608,10.265 C15.051,10.832 14.323,11.312 13.506,11.527 C12.74,11.728 11.519,11.828 10.318,11.439 C9.54,11.188 8.781,10.732 8.174,9.994 C7.564,10.975 6.46,11.779 4.852,11.744 C4.836,11.744 4.82,11.743 4.804,11.742 C4.508,11.716 4.126,11.646 3.728,11.517 L3.728,15.01 C3.728,16.444 3.729,17.443 3.831,18.198 C3.929,18.93 4.11,19.318 4.387,19.594 C4.664,19.871 5.053,20.051 5.788,20.149 C6.545,20.251 7.547,20.253 8.984,20.253 L12.988,20.253 C13.403,20.253 13.738,20.588 13.738,21.003 C13.738,21.417 13.403,21.753 12.988,21.753 L8.929,21.753 C7.56,21.753 6.457,21.753 5.589,21.636 C4.688,21.515 3.93,21.257 3.327,20.656 C2.725,20.055 2.465,19.297 2.344,18.398 C2.228,17.532 2.228,16.431 2.228,15.065 L2.228,10.658 C2.062,10.497 1.912,10.311 1.79,10.098 C1.49,9.573 1.201,9.015 1.261,8.326 C1.318,7.674 1.677,7.037 2.211,6.277 C2.714,5.561 2.96,5.046 3.083,4.673 C3.202,4.311 3.216,4.056 3.216,3.83 C3.216,3.374 3.372,2.72 3.837,2.178 C4.327,1.606 5.099,1.233 6.166,1.28 L17.774,1.252 C18.348,1.224 19.364,1.43 20.105,2.111 C20.438,2.418 20.604,2.793 20.697,3.127 Z M17.842,2.751 C17.827,2.752 17.812,2.752 17.797,2.752 L6.152,2.78 C6.139,2.78 6.126,2.78 6.113,2.779 C5.453,2.747 5.139,2.964 4.975,3.155 C4.783,3.379 4.716,3.668 4.716,3.83 C4.716,4.158 4.692,4.583 4.507,5.143 C4.326,5.691 4.002,6.338 3.439,7.139 C2.908,7.895 2.774,8.242 2.755,8.457 C2.74,8.635 2.791,8.827 3.092,9.353 C3.228,9.592 3.506,9.809 3.893,9.978 C4.261,10.138 4.65,10.22 4.909,10.245 C6.486,10.266 7.241,8.99 7.241,8.118 C7.241,7.751 7.505,7.438 7.867,7.378 C8.228,7.318 8.581,7.527 8.7,7.874 C9.137,9.146 9.948,9.743 10.78,10.012 C11.65,10.294 12.571,10.222 13.125,10.076 C13.631,9.943 14.131,9.629 14.538,9.214 C14.948,8.796 15.216,8.327 15.31,7.94 C15.397,7.587 15.723,7.346 16.086,7.369 C16.449,7.392 16.743,7.671 16.784,8.032 C16.855,8.65 16.989,9.045 17.197,9.335 C17.399,9.619 17.729,9.879 18.339,10.117 C19.356,10.514 20.29,9.932 20.888,9.403 C21.06,9.25 21.22,8.984 21.245,8.643 C21.268,8.318 21.171,7.859 20.718,7.31 C19.855,6.264 19.479,5.251 19.358,4.202 L19.355,4.175 C19.324,3.906 19.301,3.705 19.251,3.527 C19.204,3.356 19.147,3.269 19.089,3.215 C18.904,3.045 18.662,2.92 18.411,2.842 C18.154,2.762 17.94,2.745 17.842,2.751 Z M18.493,12.762 C20.827,12.762 22.747,14.618 22.747,16.942 C22.747,18.292 22.067,19.267 21.37,20.045 C21.153,20.288 20.908,20.538 20.678,20.773 C20.554,20.899 20.435,21.021 20.327,21.135 C19.996,21.482 19.716,21.806 19.503,22.144 C19.322,22.432 18.989,22.751 18.499,22.751 C18.017,22.751 17.683,22.441 17.496,22.164 C17.272,21.832 16.983,21.508 16.646,21.155 C16.558,21.062 16.465,20.965 16.369,20.867 C16.115,20.605 15.845,20.326 15.598,20.044 C14.907,19.254 14.239,18.265 14.239,16.942 C14.239,14.618 16.159,12.762 18.493,12.762 Z M15.739,16.942 C15.739,17.716 16.115,18.357 16.727,19.057 C16.947,19.308 17.176,19.544 17.418,19.794 L17.418,19.794 C17.52,19.899 17.625,20.007 17.732,20.119 C17.986,20.386 18.248,20.671 18.486,20.977 C18.723,20.659 18.985,20.369 19.24,20.101 C19.381,19.952 19.515,19.816 19.644,19.685 L19.644,19.684 C19.855,19.469 20.053,19.266 20.253,19.044 C20.868,18.358 21.247,17.734 21.247,16.942 C21.247,15.477 20.029,14.262 18.493,14.262 C16.957,14.262 15.739,15.477 15.739,16.942 Z M6.231,17.008 C6.231,16.594 6.567,16.258 6.981,16.258 L10.986,16.258 C11.4,16.258 11.736,16.594 11.736,17.008 C11.736,17.422 11.4,17.758 10.986,17.758 L6.981,17.758 C6.567,17.758 6.231,17.422 6.231,17.008 Z M17.493,17.008 C17.493,16.455 17.941,16.008 18.493,16.008 L18.502,16.008 C19.054,16.008 19.502,16.455 19.502,17.008 C19.502,17.56 19.054,18.008 18.502,18.008 L18.493,18.008 C17.941,18.008 17.493,17.56 17.493,17.008 Z" />
											</svg>

											<span className="pl-3  text-base pr-2">{oneConfigurationItems?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.MenuName}</span>
										</div>
									</li>}

								<li className="mx-2">
									<div className="flex hover:opacity-75 items-center ">
										{/* Login SVG Icon */}
										<svg width="20" height="20" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => handleNavigate('/oneuser/login')} >
											<path d="M12.8573 12.8571C16.4077 12.8571 19.2859 9.97897 19.2859 6.42857C19.2859 2.87818 16.4077 0 12.8573 0C9.30689 0 6.42871 2.87818 6.42871 6.42857C6.42871 9.97897 9.30689 12.8571 12.8573 12.8571Z" fill="white" />
											<path d="M25.7143 23.5716C25.7143 20.0211 22.8362 17.1431 19.2857 17.1431H6.42857C2.87818 17.1431 0 20.0211 0 23.5716V30.0002H25.7143V23.5716Z" fill="white" />
										</svg>

										{/* Login Text */}
									</div>
								</li>

							</ul>
						</div>
					</div>
				</>
			}
		</>

	)
}
export default HeaderV2;